import Bestellung from "@/entities/common/bestellung"
import router from "@/router"
import RouteNames from "@/util/route_names"
import ProdukteLogic from "@/logic/produkte_logic"
import Poster from "@/util/poster"
import RemoteResult from "@/entities/common/remote_result"
import RestPaths from "@/util/rest_paths"
import NachbestellenInsertRequest from "@/entities/common/request/nachbestellen_insert_request"
import ConverterUtil from "@/util/converter_util"
import Nachbestellung from "@/entities/common/nachbestellung"
import BstlArtikel from "@/entities/common/bstl_artikel"

export default class ReservierungBestellungLogic extends ProdukteLogic {
  bestellung: Bestellung = null
  bestellungCompleted: boolean = false
  insertCompleted: boolean = false

  private _warenkorb: BstlArtikel[] = []

  get warenkorbGefuellt(): boolean {
    return this._warenkorb.length > 0
  }

  bestellungEinfuegen(): void {
    router.push({
      name: RouteNames.BESTELLUNG.RESERVIERUNG_BESTELLUNG.BESTAETIGEN,
    })
  }

  bestellungAufgeben() {
    this.insertWorking = true
    this.insertError = false
    this.insertCompleted = false

    var request = new NachbestellenInsertRequest()
    request.bestellungId = this.bestellung.id

    this._warenkorb.forEach((element) => {
      request.artikel.push(ConverterUtil.convertBstlArtikel(element))
    })

    Poster.postUser<RemoteResult<Nachbestellung>>(
      RestPaths.bestellungKundeNachbestellungEinfuegen,
      request
    )
      .then((response) => {
        this.insertWorking = false
        if (response.data.success) {
          this.bestellungCompleted = true
          this.insertCompleted = true
        } else {
          this.insertError = true
        }
      })
      .catch(() => {
        this.insertWorking = false
        this.insertError = true
      })
  }

  backToOverview() {
    router.push({
      name: RouteNames.BESTELLUNG.DETAILS,
      params: { id: this.bestellung.id },
    })
  }

  get hasMindestbestellwert() {
    return false
  }

  get mindestbestellwert() {
    return 0
  }

  get kostenlosAb() {
    return 0
  }
}
